module.exports = __webpack_public_path__ + "static/8-873c2fd463e7a74a9b6cc7c1fce057aa.png";